const KCC_RESULT_CONTEXT_KEY_SEP = '____'

const getKColorResultContextKey = (
  product,
  color,
  productPackage
) => {
  return !!product && !!color && !!productPackage?[
    product,
    color,
    productPackage
  ].join(KCC_RESULT_CONTEXT_KEY_SEP):undefined;
}

export default getKColorResultContextKey;
